<template>
  <div
    v-if="invite"
    class="invite text-white text-center align-items-center flex-column justify-content-center flex-wrap d-flex mt-5"
  >
    <div class="w-100 mb-5">
      <app-avatar
        v-if="invite"
        size="lg"
        :name="inviterFullName"
        :url="inviterAvatarUrl"
      />
      <p class="mt-2">
        <strong>{{
          "invite.inviter" | trans({ name: inviterFullName })
        }}</strong>
      </p>
      <h2 class="mt-4">
        <template v-if="customer">
          {{ "invite.title" | trans({ name: customer.firstName }) }}
        </template>
        <template v-else>
          {{ "invite.title_unauth" | trans }}
        </template>
      </h2>
      <p>{{ "invite.desc" | trans }}</p>
    </div>
    <b-form @submit.prevent="onSubmit" class="w-100">
      <app-button
        :disabled="submitted"
        :loading="submitted"
        type="submit"
        variant="light"
        size="lg"
        block
        >{{ "invite.button.join.label" | trans }}</app-button
      >
      <app-button
        :href="$trans('invite.button.learn_more.link')"
        size="lg"
        target="_blank"
        block
        >{{ "invite.button.learn_more.label" | trans }}
      </app-button>
      <p class="mt-5 small">
        {{ "invite.info" | trans }}
      </p>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppAvatar from "@/components/user/Avatar";
import AppButton from "@/components/ui/Button";
import cookies from "@/storage/cookies";
import { INVITE_COOKIE_NAME } from "@/constants";
import { createValidationError } from "@/utils/validation";

export default {
  name: "InviteView",
  components: { AppButton, AppAvatar },
  props: {
    code: {
      type: String,
      required: true,
      default: null,
    },
  },
  async created() {
    if (!this.code) {
      this.$router.push({ name: "not-found" });
      return;
    }

    try {
      if (this.isAlreadyParticipant) {
        return this.$router.push({ name: "my-plane" });
      }

      let res = await this.getFriendListInvite(this.code);
      this.invite = res.data;
    } catch (e) {
      this.$router.push({ name: "not-found" });
    }
  },
  computed: {
    ...mapGetters("customers", ["customer"]),
    ...mapGetters("friendLists", ["invitedFriendList"]),
    inviterFullName() {
      return this.invite.inviterFullName;
    },
    inviterAvatarUrl() {
      return this.invite.inviterAvatarUrl;
    },
    isAlreadyParticipant() {
      return this.customer && this.customer.invitedFriendListId;
    },
  },
  methods: {
    ...mapActions("friendLists", [
      "getFriendListInvite",
      "validateFriendListInvite",
      "acceptFriendListInvite",
    ]),
    ...mapActions("customers", ["getCustomer"]),
    async onSubmit() {
      try {
        this.submitted = true;
        await this.join();
      } finally {
        this.submitted = false;
      }
    },
    async join() {
      if (!this.customer) {
        await cookies.set(INVITE_COOKIE_NAME, this.code, { expires: 30 });
        this.$router.push({ name: "login" });
        return;
      }

      try {
        await cookies.remove(INVITE_COOKIE_NAME);
        await this.acceptFriendListInvite(this.code);
        await this.getCustomer();
      } catch (e) {
        const ve = createValidationError(e);
        ve.errors.forEach(error => this.$flash(error.reason, "error"));
      } finally {
        this.$router.push({ name: "my-plane" });
      }
    },
  },
  data() {
    return {
      invite: null,
      submitted: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.invite {
  min-height: calc(100vh - 4.125rem);
  max-width: 23.75rem;
  margin: auto;
}
</style>
